import React from 'react';
import PropTypes from 'prop-types';

import './ToggleButton.css';

const ToggleButton = ({
  repliesCollapsed,
  handleRepliesCollapseClick,
  labelHide,
  labelView
}) => {
  return (
    <button
      type="button"
      styleName="button"
      className=""
      onClick={handleRepliesCollapseClick}
    >
      <span styleName="label">{repliesCollapsed ? labelView : labelHide}</span>
      <span styleName={`chevron ${repliesCollapsed ? 'show' : 'hide'}`} />
    </button>
  );
};

ToggleButton.propTypes = {
  repliesCollapsed: PropTypes.bool.isRequired,
  handleRepliesCollapseClick: PropTypes.func.isRequired,
  labelHide: PropTypes.string.isRequired,
  labelView: PropTypes.string.isRequired
};

export default ToggleButton;
